var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import '../../css/clydePillSelect.css';
var colors = {
    borderGray: '#D1D1D1',
    lightestGray: '#EEEEEE',
    primaryBlack: '#000',
};
export var createPillSelectStyles = function (direction) {
    var valueContainerStyle = direction === 'col'
        ? function (base) { return (__assign(__assign({}, base), { flexDirection: 'column', width: 'fit-content', justifyContet: 'space-around', marginTop: '0px', marginLeft: '-2px' })); } : function (base) { return (__assign(__assign({}, base), { marginTop: '0px', marginLeft: '-2px' })); };
    var createIndicatorsContainerStyle = direction === 'col'
        ? function (base) { return (__assign(__assign({}, base), { alignSelf: 'flex-start', marginTop: '5%', marginRight: '5px', marginLeft: '-5px' })); } : function (base) { return (__assign(__assign({}, base), { flexDirection: 'col', justifyContent: 'space-around', marginRight: '5px', marginLeft: '-5px' })); };
    var createPlaceholderStyle = direction === 'col'
        ? function () { return ({
            fontFamily: 'Volte',
            alignSelf: 'left',
            width: 'fit-content',
            textWrap: 'no-wrap',
            margin: '8px 11px -15px 13px',
            paddingBottom: '2px',
            paddingLeft: '2px',
            minWidth: '70px',
        }); } : function (base) { return (__assign(__assign({}, base), { color: 'inherit', position: 'relative', fontFamily: 'Volte', alignSelf: 'left', width: 'fit-content', textWrap: 'no-wrap', margin: '17px 10px -4px 15px', minWidth: '70px', minHeight: '16px' })); };
    return ({
        clearIndicator: function () { return ({ display: 'none' }); },
        container: function (base) { return (__assign(__assign({}, base), { width: direction === 'col' ? 'fit-content' : base.width, height: 'fit-content' })); },
        control: function (base, state) { return (__assign(__assign({}, base), { 'border': "1px solid ".concat(colors.borderGray), 'borderRadius': '8px', 'cursor': 'pointer', 'minHeight': 0, 'outline': 0, 'margin': 0, 'boxShadow': state.isFocused ? 0 : 0, 'z-index': 2, '&:focus': {
                border: "1px solid ".concat(colors.borderGray),
                boxShadow: 0,
            }, '&:hover': {
                boxShadow: state.isFocused ? 0 : 0,
            } })); },
        indicatorsContainer: function (base) { return createIndicatorsContainerStyle(base); },
        indicatorSeparator: function () { return ({ display: 'none' }); },
        menu: function (base) { return (__assign(__assign({}, base), { borderRadius: '-8px -8px 8px 8px', marginTop: '-5px', paddingTop: '6px', boxShadow: 0, border: "1px solid ".concat(colors.borderGray) })); },
        menuList: function (base) { return (__assign(__assign({}, base), { borderRadius: '0px 0px 8px 8px' })); },
        multiValue: function (base) { return (__assign(__assign({}, base), { color: colors.primaryBlack, backgroundColor: colors.lightestGray, borderRadius: '8px', padding: '3px 7px 3px 7px', margin: 1 })); },
        multiValueLabel: function (base) { return (__assign(__assign({}, base), { color: colors.primaryBlack, fontSize: '16px', fontFamily: 'Volte', margin: '3px 0px', marginLeft: 0 })); },
        multiValueRemove: function (base) { return (__assign(__assign({}, base), { 'marginTop': '-2px', 'color': colors.primaryBlack, '&:hover': {
                color: 'inherit',
                backgroundColor: 'inherit',
            } })); },
        option: function (base) { return (__assign(__assign({}, base), { 'backgroundColor': 'inherit', 'color': 'inherit', 'fontFamily': 'Volte', 'paddingLeft': '5px', '&:hover': {
                color: 'inherit',
                backgroundColor: colors.lightestGray,
            }, '&:active': {
                color: 'inherit',
                backgroundColor: colors.lightestGray,
            } })); },
        placeholder: function (base) { return createPlaceholderStyle(base); },
        valueContainer: function (base) { return valueContainerStyle(base); },
    });
};
